import { render, staticRenderFns } from "./getPhoneCode.vue?vue&type=template&id=528d3d83&scoped=true&"
import script from "./getPhoneCode.vue?vue&type=script&lang=js&"
export * from "./getPhoneCode.vue?vue&type=script&lang=js&"
import style0 from "./getPhoneCode.vue?vue&type=style&index=0&id=528d3d83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528d3d83",
  null
  
)

export default component.exports